import { FundingNotes } from './FundingNotes';

export default FundingNotes;
